<div class="md:h-full">
  <router-outlet></router-outlet>
</div>
